import script from "./EditEntryFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEntryFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditEntryFormComponent.vue?vue&type=style&index=0&id=60e947a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e947a4"]])

export default __exports__